import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/redux/store";
import { useSelector } from "react-redux";

import { getProfileInfo } from "@/redux/profile/settings/getProfileInfo/selectors";
import { fetchProfileInfo } from "@/redux/profile/settings/getProfileInfo/asyncActions";

import { LogoutConfirmModal } from "../LogoutConfirmModal";
import historyIcon from "@/assets/icons/profileHistory.svg";
import cardIcon from "@/assets/icons/profileCard.svg";
import settingsIcon from "@/assets/icons/profileSettings.svg";
import logoutIcon from "@/assets/icons/profileLogout.svg";
import Styles from "./ProfileMainScreen.module.scss";

const formatClientCode = (userId: number | string | undefined): string => {
  if (!userId) return "#0000";

  const userIDStr = String(userId);
  const minLength = 4;
  const paddingLength = Math.max(0, minLength - 1 - userIDStr.length);

  return `#${'0'.repeat(paddingLength)}${userIDStr}`;
};

export const ProfileMainScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { profileInfo } = useSelector(getProfileInfo);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = React.useState(false);

  useEffect(() => {
    dispatch(fetchProfileInfo());
  }, [dispatch]);

  const handleNavigate = (route: string) => {
    navigate(`/profile/${route}`);
  };

  const handleClickHistory = () => {
    handleNavigate("history");
  };

  const handleClickCards = () => {
    handleNavigate("cards");
  };

  const handleClickSettings = () => {
    handleNavigate("settings");
  };

  const handleClickLogout = () => {
    setIsLogoutModalOpen(true);
  };

  const handleClickAbout = () => {
    navigate("/about-app");
  };

  const userName = profileInfo?.name || "";
  const userID = profileInfo?.id;
  const clientCode = formatClientCode(userID);

  return (
    <>
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <div className={Styles.userInfo}>
            <h2 className={Styles.userName}>{userName || "Пользователь"}</h2>
            <div className={Styles.clientCodeRow}>
              <span className={Styles.clientCodeLabel}>Код клиента </span>
              <span className={Styles.clientCode}>{clientCode}</span>
            </div>
          </div>
        </div>

        <div className={Styles.menu}>
          <div className={Styles.menuItem} onClick={handleClickHistory}>
            <div className={Styles.menuItemLeft}>
              <img className={Styles.menuItemIcon} src={historyIcon} alt="history" />
              <span>История покупок</span>
            </div>
          </div>
          <div className={Styles.menuSeparator} />
          <div className={Styles.menuItem} onClick={handleClickCards}>
            <div className={Styles.menuItemLeft}>
              <img className={Styles.menuItemIcon} src={cardIcon} alt="cards" />
              <span>Привязанные карты</span>
            </div>
          </div>
          <div className={Styles.menuSeparator} />
          <div className={Styles.menuItem} onClick={handleClickSettings}>
            <div className={Styles.menuItemLeft}>
              <img className={Styles.menuItemIcon} src={settingsIcon} alt="settings" />
              <span>Настройки профиля</span>
            </div>
          </div>

          <div className={`${Styles.menuItem} ${Styles.menuItem_logout}`} onClick={handleClickLogout}>
            <div className={Styles.menuItemLeft}>
              <img className={Styles.menuItemIcon} src={logoutIcon} alt="logout" />
              <span>Выход</span>
            </div>
          </div>
        </div>

        <div className={Styles.aboutButton} onClick={handleClickAbout}>
          О приложении
        </div>
      </div>

      <LogoutConfirmModal
        isOpen={isLogoutModalOpen}
        setIsOpen={setIsLogoutModalOpen}
      />
    </>
  );
};
